export default __webpack_public_path__ + "static/media/play.0e3a2b77.svg";